import {lazyWithRetry} from '../../libs/ui/src';

export const SignInPage = lazyWithRetry(() => import('./SignInPage'));
